/**--external-- */
import React from "react";
import PropTypes from "prop-types";

/**--internal -- */
import ButtonDropdown from "UIComponents/ButtonDropdown";

/**--relative-- */
import { containerStyle } from "./Level3FilterStyles";
import DropdownContent from "./DropdownContent";
import {
  getFlattenOptionsMemoized,
  getFlattenValuesMemoized,
} from "./Level3FilterUtils";

const Level3Filter = props => {
  const {
    parentContainerStyle,
    buttonDropDownContainerStyle,
    label,
    getAllOptionLabel,
    onUpdateShowDropDown,
    isDisabled,
    optionList,
    valueList,
    getSearchPlaceholder,
    updateInputField,
  } = props;

  const options = getFlattenOptionsMemoized({ optionList });

  const values = getFlattenValuesMemoized({ valueList });

  const buttonElement = React.cloneElement(props.buttonElement, {
    label,
    options,
    values,
  });

  const placeholder = getSearchPlaceholder({ label });

  return (
    <ButtonDropdown
      shouldCloseOnSelfClick={false}
      parentContainerStyle={parentContainerStyle}
      containerStyle={{ ...containerStyle, ...buttonDropDownContainerStyle }}
      buttonComponent={buttonElement}
      dropdownComponent={
        <DropdownContent
          optionList={optionList}
          placeholder={placeholder}
          updateInputField={updateInputField}
          valueList={valueList}
          getAllOptionLabel={getAllOptionLabel}
        />
      }
      onUpdateShowDropDown={onUpdateShowDropDown}
      disabled={isDisabled}
    />
  );
};

Level3Filter.displayName = "Level3Filter";

Level3Filter.defaultProps = {
  parentContainerStyle: {},
  buttonDropDownContainerStyle: {},
  isDisabled: false,
};

Level3Filter.propTypes = {
  parentContainerStyle: PropTypes.object,
  buttonDropDownContainerStyle: PropTypes.object,
  label: PropTypes.string,
  getAllOptionLabel: PropTypes.func,
  onUpdateShowDropDown: PropTypes.func,
  isDisabled: PropTypes.bool,
  optionList: PropTypes.array,
  valueList: PropTypes.array,
  getSearchPlaceholder: PropTypes.func,
  updateInputField: PropTypes.func,
};

export default Level3Filter;
